export const TUTORIALS_REFRESH_TTL_MS = 15 * 60 * 1000
export const TUTORIALS_FETCH_RETRY_COOL_DOWN_MS = 60 * 1000

interface ShouldRefreshTutorialsParams {
  tutorialsCount: number
  lastFetchedAt: number | null
  lastFailedFetchAttemptAt: number | null
  isFetching: boolean
}

export const shouldRefreshTutorials = ({
  tutorialsCount,
  lastFetchedAt,
  lastFailedFetchAttemptAt,
  isFetching,
}: ShouldRefreshTutorialsParams) => {
  const now = Date.now()

  if (isFetching) {
    return false
  }

  if (tutorialsCount === 0) {
    if (
      lastFailedFetchAttemptAt !== null &&
      now - lastFailedFetchAttemptAt < TUTORIALS_FETCH_RETRY_COOL_DOWN_MS
    ) {
      return false
    }

    return true
  }

  if (lastFetchedAt === null) {
    if (
      lastFailedFetchAttemptAt !== null &&
      now - lastFailedFetchAttemptAt < TUTORIALS_FETCH_RETRY_COOL_DOWN_MS
    ) {
      return false
    }

    return true
  }

  if (
    lastFailedFetchAttemptAt !== null &&
    now - lastFailedFetchAttemptAt < TUTORIALS_FETCH_RETRY_COOL_DOWN_MS
  ) {
    return false
  }

  return now - lastFetchedAt > TUTORIALS_REFRESH_TTL_MS
}
